export default "__VITE_ASSET__cqTq1EzL__"